/**
 * Created by piotr.pozniak@thebeaverhead.com on 23/05/2024
 */

import React from "react";

const BackButton = ({ show, label, url }) => {
  if (!show) {
    return null;
  }

  return (
    <div className={"dc-calendar-branding--header-backbutton-container"}>
      <a href={url} className="dc-calendar-branding--back-button">
        {label}
      </a>
    </div>
  );
};

export default BackButton;
